<div class="filters row mb-3">
	<div class="col-sm-3 text-left mb-3">
		<button
			nbButton
			status="primary"
			(click)="openDialog()"
			*ngxPermissionsOnly="[
				OrganizationPermissionsEnum.ALLOW_MANUAL_TIME
			]"
		>
			<nb-icon icon="plus-outline"></nb-icon>
			{{ 'TIMESHEET.ADD_TIME' | translate }}
		</button>
	</div>
	<div class="col">
		<ngx-filters
			[hasDateRangeFilter]="false"
			[hasEmployeeFilter]="false"
			[hasProjectFilter]="false"
			(filtersChange)="filtersChange($event)"
		></ngx-filters>
	</div>
</div>

<full-calendar
	#calendar
	[options]="calendarOptions"
	[nbSpinner]="loading"
	nbSpinnerSize="giant"
	nbSpinnerStatus="primary"
></full-calendar>
